import React from 'react'

export default function DueDiligence() {
  return (
    <div>DueDiligence</div>
  )
}
